import { TokenizedCreditCardID } from "../credit-card/credit-card.types"
import { UserID } from "../../user/user.interface"

export type PaymentMethodType =
  | "unknown"
  | "card"
  | "cashapp"
  | "affirm"
  | "afterpay_clearpay"
  | "klarna"
  | "zip"

export type PaymentMethodCardBrand =
  | "amex"
  | "diners"
  | "discover"
  | "jcb"
  | "mastercard"
  | "unionpay"
  | "visa"

export type PaymentMethodDisplayType =
  | "default"
  | "affirm"
  | "afterpay_clearpay"
  | "card-amex"
  | "card-diners"
  | "card-discover"
  | "card-jcb"
  | "card-mastercard"
  | "card-unionpay"
  | "card-visa"
  | "card-wallet-apple_pay"
  | "card-wallet-google_pay"
  | "card-wallet-link"
  | "card-wallet-amex_express_checkout"
  | "card-wallet-masterpass"
  | "card-wallet-samsung_pay"
  | "card-wallet-visa_checkout"
  | "cashapp"
  | "klarna"
  | "zip"

/**
 * @see https://docs.stripe.com/payments/payment-methods/overview
 */
export type PaymentMethodDetails = {
  type: PaymentMethodType
  displayType: PaymentMethodDisplayType
  displayName: string
  imagePath: string
}

export enum PaymentMethodProviderEnum {
  StripeACH = "stripeACH",
  Plaid = "plaid",
  CreditCard = "creditCard",
}

export type PaymentMethodProvider = `${PaymentMethodProviderEnum}` | PaymentMethodProviderEnum

export type PaymentMethodID = string
export type PaymentMethod = {
  id: PaymentMethodID
  userId: UserID

  provider: PaymentMethodProvider

  type: PaymentMethodType
  displayType: PaymentMethodDisplayType
  displayName: string

  // Credit card related data
  creditCardId?: TokenizedCreditCardID
  creditCardTokenId?: string

  // Stripe ACH
  stripeCustomerId?: string
  stripePaymentMethodId?: string
  stripeSetupIntentId?: string
}
